import { Box } from '@vouched.id/vault';
import React, { useMemo } from 'react';
import { Tooltips } from '../../tooltips';
import { itemHasErrorOrWarning } from '../../utils';
import { Dropdown } from '../Dropdown';
import { addIconsToDropdownItems, DropdownItemTypes } from '../utils';
import { ReviewCaption } from './ReviewCaption';
import { ReviewTable } from './ReviewTable';
import { IdDocumentItemTitle } from 'components/account/jobs-v2/dropdowns/IdDocument/utils';
import { IdvError } from 'models/jobs/jobs';
const DLV_REJECTION_KEY = 'id-dlv-mismatch';
export const ReviewDropdowns = ({ jobConfidences, jobErrors, jobReview, jobSid, onReviewSubmitted, dlvCheckPerformed, rejectionReasons, isReverificationJob }) => {
    const idConfidence = jobConfidences.id;
    const selfieConfidence = jobConfidences.selfie;
    const faceMatchConfidence = jobConfidences.faceMatch;
    const nameMatchConfidence = jobConfidences.nameMatch;
    const birthDateMatchConfidence = jobConfidences.birthDateMatch;
    const barcodeMatchConfidence = jobConfidences.barcodeMatch;
    const { dropdownItems } = useMemo(() => {
        const dropdownItemsWithoutIcons = [
            {
                text: IdDocumentItemTitle.ValidPhysicalId,
                type: DropdownItemTypes.ConfidenceDropdownItem,
                available: typeof idConfidence === 'number',
                hasErrorOrWarning: itemHasErrorOrWarning(jobErrors, IdvError.InvalidIdPhotoError),
                tooltip: Tooltips.ValidPhysicalId,
                reviewLabel: 'idValid'
            },
            {
                text: IdDocumentItemTitle.ValidSelfie,
                type: DropdownItemTypes.ConfidenceDropdownItem,
                available: typeof selfieConfidence === 'number',
                hasErrorOrWarning: itemHasErrorOrWarning(jobErrors, IdvError.InvalidUserPhotoError),
                tooltip: Tooltips.ValidSelfie,
                reviewLabel: 'selfieValid'
            },
            {
                text: isReverificationJob
                    ? IdDocumentItemTitle.SelfieMatchesReferenceImage
                    : IdDocumentItemTitle.IdMatchesSelfie,
                type: DropdownItemTypes.ConfidenceDropdownItem,
                available: typeof faceMatchConfidence === 'number',
                hasErrorOrWarning: itemHasErrorOrWarning(jobErrors, IdvError.FaceMatchError),
                tooltip: isReverificationJob
                    ? Tooltips.SelfieMatchesReferenceImage
                    : Tooltips.IdMatchesSelfie,
                reviewLabel: 'faceMatch'
            },
            {
                text: IdDocumentItemTitle.IdMatchesBarcode,
                type: DropdownItemTypes.ConfidenceDropdownItem,
                available: typeof barcodeMatchConfidence === 'number',
                hasErrorOrWarning: itemHasErrorOrWarning(jobErrors, IdvError.BarcodeMatchError),
                tooltip: Tooltips.IdMatchesBarcode,
                reviewLabel: 'barcodeMatch'
            },
            {
                text: IdDocumentItemTitle.IdMatchesSubmittedName,
                type: DropdownItemTypes.ConfidenceDropdownItem,
                available: typeof nameMatchConfidence === 'number',
                hasErrorOrWarning: itemHasErrorOrWarning(jobErrors, IdvError.NameMatchError),
                tooltip: Tooltips.IdMatchesSubmittedName,
                reviewLabel: 'nameMatch'
            },
            {
                text: IdDocumentItemTitle.IdMatchesSubmittedDob,
                type: DropdownItemTypes.ConfidenceDropdownItem,
                available: typeof birthDateMatchConfidence === 'number',
                hasErrorOrWarning: itemHasErrorOrWarning(jobErrors, IdvError.BirthDateMatchError),
                tooltip: Tooltips.IdMatchesSubmittedDOB,
                reviewLabel: 'birthDateMatch'
            },
            {
                text: IdDocumentItemTitle.ValidDriverLicense,
                type: DropdownItemTypes.ConfidenceDropdownItem,
                available: dlvCheckPerformed === true,
                hasErrorOrWarning: {
                    hasError: rejectionReasons?.some((reason) => reason.key === DLV_REJECTION_KEY) ?? false,
                    hasWarning: false
                },
                reviewLabel: 'dlvValid'
            }
        ];
        return addIconsToDropdownItems(dropdownItemsWithoutIcons);
    }, [
        jobErrors,
        idConfidence,
        selfieConfidence,
        faceMatchConfidence,
        nameMatchConfidence,
        birthDateMatchConfidence,
        barcodeMatchConfidence,
        dlvCheckPerformed,
        rejectionReasons
    ]);
    return (React.createElement(Dropdown, { title: "Review" },
        React.createElement(Box, null,
            React.createElement(ReviewCaption, null),
            React.createElement(ReviewTable, { dropdownItems: dropdownItems.filter((item) => item.available && item.reviewLabel), jobReview: jobReview, jobSid: jobSid, onReviewSubmitted: onReviewSubmitted }))));
};
